import axios from 'axios';

const request = axios.create({
  baseURL: process.env.VUE_APP_SERVER_ENDPOINT,
});

/* ----------------------------------
   AUTH HEADER (ONCE)
---------------------------------- */
const token = localStorage.getItem('token');
if (token) {
  request.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

/* ----------------------------------
   REQUEST INTERCEPTOR 
---------------------------------- */
request.interceptors.request.use(
  (config) => {
    const cashier_id = localStorage.getItem('cashier_id');

    // Only apply to this endpoint
    if (
      cashier_id &&
      config.url &&
      config.url.includes('/api/session/update')
    ) {
      // Ensure body exists
      if (!config.data) {
        config.data = {};
      }

      config.data.cashier_id = cashier_id;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default request;
